import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import "./AdminSettings.css";

import {
  getAdminProfile,
  updateAdminProfile,
  changeAdminPassword,
  updateAdminProfilePicture,
} from "../../api/adminSettingsApi";

const AdminSettings = () => {
  const [activeTab, setActiveTab] = useState("profile");
  const [isEditingProfile, setIsEditingProfile] = useState(false);

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [role, setRole] = useState("");
  const [profileImage, setProfileImage] = useState("");

  const [passwords, setPasswords] = useState({
    current: "",
    next: "",
    confirm: "",
  });

  // 🔹 Fetch admin profile
  const fetchProfile = async () => {
    try {
      const res = await getAdminProfile();
      const data = res.data;

      // setFirstName(data.firstName);
      // setLastName(data.lastName);
      setName(data.username);
      setEmail(data.email);
      setRole(data.role);
      // setProfileImage(data.profileImage);
      setProfileImage(data.profilePic);
    } catch (err) {
      console.error(err);
      toast.error("Failed to load profile");
    }
  };

  useEffect(() => {
    fetchProfile();
  }, []);

  // 🔹 Save profile
  const handleProfileSave = async (e) => {
    e.preventDefault();
    try {
      await updateAdminProfile({ username: name });
      toast.success("Profile updated successfully");
      setIsEditingProfile(false);
      fetchProfile();
    } catch (err) {
      console.error(err);
      toast.error("Profile update failed");
    }
  };

  // 🔹 Change password
  const handlePasswordSubmit = async (e) => {
    e.preventDefault();

    if (!passwords.current || !passwords.next) {
      toast.error("All fields required");
      return;
    }

    if (passwords.next !== passwords.confirm) {
      toast.error("Passwords do not match");
      return;
    }

    try {
      await changeAdminPassword({
        currentPassword: passwords.current,
        newPassword: passwords.next,
      });

      toast.success("Password updated successfully");
      setPasswords({ current: "", next: "", confirm: "" });
    } catch (err) {
      console.error(err);
      toast.error("Password update failed");
    }
  };

  // 🔹 Change profile picture
  const handleImageChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("profile", file);

    try {
      const res = await updateAdminProfilePicture(formData);
      console.log("API Response:", res);

      setProfileImage(res.data.updatedResult.profilePic);
      toast.success("Profile picture updated");
    } catch (err) {
      // console.error(err);
      console.error(err);
      toast.error("Image upload failed");
    }
  };

  return (
    <div className="admin-container">
      <header className="settings-header">
        <h3>Admin Settings</h3>
        <p>Manage your profile and security settings</p>
      </header>

      <section className="settings-card">
        <div className="tab-row">
          <button
            className={
              activeTab === "profile" ? "tab-admin active" : "tab-admin"
            }
            onClick={() => setActiveTab("profile")}
          >
            Profile
          </button>
          <button
            className={
              activeTab === "settings" ? "tab-admin active" : "tab-admin"
            }
            onClick={() => setActiveTab("settings")}
          >
            Settings
          </button>
        </div>

        <div className="admin-layout">
          {/* ================= PROFILE TAB ================= */}
          {activeTab === "profile" && (
            <>
              {isEditingProfile ? (
                <>
                  <div className="profile-card-header">
                    <h2 className="section-title">Profile Information</h2>
                    <div className="actions-right">
                      <button
                        className="primary-btn btn-ghost"
                        onClick={() => setIsEditingProfile(false)}
                      >
                        Back
                      </button>
                      <button
                        type="submit"
                        form="profile-form"
                        className="primary-btn"
                      >
                        Save Details
                      </button>
                    </div>
                  </div>

                  <div className="profile-grid">
                    <div className="profile-photo-card">
                      {/* <div
                        className="profile-photo-circle"
                        style={{
                          backgroundImage: `url(${profileImage})`,
                        }}
                      /> */}
                      <div className="profile-photo-circle">
                        {profileImage ? (
                          <img src={profileImage} alt="Profile" />
                        ) : null}
                      </div>
                      <label className="primary-btn">
                        Change Photo
                        <input
                          type="file"
                          hidden
                          onChange={handleImageChange}
                        />
                      </label>
                    </div>

                    <form
                      id="profile-form"
                      className="profile-form"
                      onSubmit={handleProfileSave}
                    >
                      <div className="field-row">
                        <div className="field">
                          <label>Name</label>
                          <input
                            // value={firstName}
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                          />
                        </div>
                        {/* <div className="field">
                          <label>Last Name</label>
                          <input
                            value={lastName}
                            onChange={(e) => setLastName(e.target.value)}
                          />
                        </div> */}
                      </div>

                      <div className="field-row">
                        <div className="field">
                          <label>Email Address</label>
                          <input value={email} disabled />
                        </div>
                      </div>
                    </form>
                  </div>
                </>
              ) : (
                <>
                  <div className="profile-card-header">
                    <h2 className="section-title">Profile Information</h2>
                    <button
                      className="primary-btn"
                      onClick={() => setIsEditingProfile(true)}
                    >
                      Edit Details
                    </button>
                  </div>

                  <div className="profile-grid">
                    <div className="profile-photo-card">
                      {/* <div
                        className="profile-photo-circle"
                        style={{
                          backgroundImage: `url(${profileImage})`,
                        }}
                      /> */}
                      <div className="profile-photo-circle">
                        {profileImage ? (
                          <img src={profileImage} alt="Profile" />
                        ) : null}
                      </div>
                      <div className="profile-name">
                        {firstName} {lastName}
                      </div>
                      <div className="profile-role">{role}</div>
                    </div>

                    <div className="profile-static-card">
                      <span className="user-info-title">User Information</span>
                      <div className="profile-static-body">
                        <p className="label">Name</p>
                        <p className="value">{name}</p>
                        <p className="label">Email</p>
                        <p className="value">{email}</p>
                      </div>

                      {/* <div className="flex space-x-2">
                        <label className="text-gray-200 ">Name: </label>
                        <span>{name}</span>
                      </div>
                      <div></div> */}
                    </div>
                  </div>
                </>
              )}
            </>
          )}

          {/* ================= SETTINGS TAB ================= */}
          {activeTab === "settings" && (
            <>
              <h2 className="section-title">Security Settings</h2>
              <div className="password-card">
                <h5>Change Password</h5>
                <form onSubmit={handlePasswordSubmit}>
                  <div className="field">
                    <label>Current Password</label>
                    <input
                      type="password"
                      value={passwords.current}
                      onChange={(e) =>
                        setPasswords({ ...passwords, current: e.target.value })
                      }
                    />
                  </div>

                  <div className="field">
                    <label>New Password</label>
                    <input
                      type="password"
                      value={passwords.next}
                      onChange={(e) =>
                        setPasswords({ ...passwords, next: e.target.value })
                      }
                    />
                  </div>

                  <div className="field">
                    <label>Confirm Password</label>
                    <input
                      type="password"
                      value={passwords.confirm}
                      onChange={(e) =>
                        setPasswords({
                          ...passwords,
                          confirm: e.target.value,
                        })
                      }
                    />
                  </div>

                  <button type="submit" className="primary-btn">
                    Submit
                  </button>
                </form>
              </div>
            </>
          )}
        </div>
      </section>
    </div>
  );
};

export default AdminSettings;
